export default {"src":"/_next/static/media/warn.7efb48be.svg","height":24,"width":24};